module.exports = __webpack_public_path__ + "img/icons-yrykb-tksq.0f44de94.png";